import { createFileRoute } from "@tanstack/react-router";

import { ErrorState } from "@/components/ui";

import { SpaceRuns } from "../features/console";
import { spaceByCode } from "../features/console/spaces/lib/address";
import { useConsole } from "../features/console/store";

export const Route = createFileRoute("/console/spaces/$joinCode/runs")({
  component: SpaceRunsRoute,
});

function SpaceRunsRoute() {
  const { joinCode } = Route.useParams();
  const space = useConsole((state) => spaceByCode(state.spaces, joinCode));
  if (space === undefined) return <ErrorState headline="No such space" />;
  return <SpaceRuns space={space} />;
}
